import axios from 'axios';
import * as types from "../constants";

export const createTask = (task) => async dispatch => {
  try {
    const formData = new FormData();
    if(task.file){
      formData.append('file', task.file);
    }
    formData.append('area', task.area);
    formData.append('assignedTo', JSON.stringify(task.assignedTo));
    formData.append('jobDescription', task.jobDescription);
    formData.append('assignedBy', JSON.stringify(task.assignedBy));
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    console.log(formData)
    const res = await axios.post('/api/jobs/', formData, config);

    dispatch({
      type: types.CREATE_TASK,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}

export const getTask = () => async dispatch => {
  try {
    let res = await axios.get('/api/jobs/')
    dispatch({
      type: types.GET_TASK,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}

export const completeTask = (task) => async dispatch => {
  try {
    let res = await axios.post('/api/jobs/setComplete', task)
    console.log(res.data)
    dispatch({
      type: types.COMPLETE_TASK,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}

export const getEmployees = (task) => async dispatch => {
  try {
    const res = await axios.get('/api/jobs/users');
    dispatch({
      type: types.GET_EMPLOYEES,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}
